import './ScrollShadow.scss';

import { useOnMount } from '@hooks';

import React, { PropsWithChildren, ReactElement, RefObject, useRef } from 'react';

export interface ScrollShadowProps {
	shadow: string;
	scroller: string;
}

export const ScrollShadow: React.FC<PropsWithChildren<ScrollShadowProps>> = ({ children, scroller, shadow }) => {
	const containerRef: RefObject<HTMLDivElement> = useRef(null);

	useOnMount(() => {
		containerRef.current?.querySelector(scroller)?.addEventListener('scroll', (e: Event) => {
			const shadowTarget = containerRef.current?.querySelector(shadow);

			if (!shadowTarget) {
				return;
			}

			shadowTarget.classList.toggle('drop-shadow', (e.target as HTMLElement).scrollTop > 0);
		});

		containerRef.current?.querySelector(shadow)?.classList.add('scroll-shadow');
	});

	if (!children) {
		return null;
	}

	return React.cloneElement(children as ReactElement, { ref: containerRef });
};
